import { EntityFileModel } from "../file/entity-file-model";

export class FileRequestModel {
    getFileList: EntityFileModel = new EntityFileModel;
    fileId?: string;
}